/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconDotsVertical,
  IconDownload,
  IconEye,
  IconPlus,
} from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import CommonModal from "../../../components/common/CommonModal";
import EditViewModal from "./EditViewModal";
import ToggleButton from "../../../components/ToggleButton";
import AddZoneModal from "./AddZoneModal";
import ViewCitiesModal from "./ViewCitiesModal";

const zoneData = [
  {
    id: 1,
    zoneName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    price: "500",
    capacity: "100 per day",
    courierCompany: "Blue Logistics",
    city: "View Cities",
    paymentType: "CC,COD",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 2,
    zoneName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    price: "500",
    capacity: "100 per day",
    courierCompany: "Blue Logistics",
    city: "View Cities",
    paymentType: "CC,COD",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 3,
    zoneName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    price: "500",
    capacity: "100 per day",
    courierCompany: "Blue Logistics",
    city: "View Cities",
    paymentType: "CC,COD",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 4,
    zoneName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    price: "500",
    capacity: "100 per day",
    courierCompany: "Blue Logistics",
    city: "View Cities",
    paymentType: "CC,COD",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 5,
    zoneName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    price: "500",
    capacity: "100 per day",
    courierCompany: "Blue Logistics",
    city: "View Cities",
    paymentType: "CC,COD",
    date: "4 Aug 2025",
    active: true,
  },
];

export default function ZoneListTab() {
  const [openZone, setOpenZone] = useState<boolean>(false);
  const openZoneToggleModal = () => {
    setOpenZone(!openZone);
  };

  const [openEditZone, setOpenEditZone] = useState<boolean>(false);
  const openEditZoneToggleModal = () => {
    setOpenEditZone(!openEditZone);
  };

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <div className="bg-[#F7F6F2] rounded-3xl">
        <div className="flex justify-between items-center w-full p-4">
          <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
            <h1 className="text-3xl text-[#212121]">Zone List</h1>
          </div>
          <div className=" flex items-center gap-2 justify-end rounded-full">
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch />
            </div>
            <button className="flex items-center gap-1 py-2 px-4 text-sm rounded-full border border-[#D8D8D8] bg-white">
              <IconDownload /> Export
            </button>
            <button
              onClick={openZoneToggleModal}
              className="flex items-center gap-1  p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
            >
              <IconPlus />
            </button>
          </div>
        </div>
        <div>
          {" "}
          <ListView
            data={zoneData}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "S/N", render: (_, i) => i + 1 },
              {
                label: "Zone Name",
                render: (c) => c.zoneName,
              },
              {
                label: "Warehouse",
                render: (c) => c.warehouse,
              },
              { label: "Country", render: (c) => c.country },
              {
                label: "Price",
                render: (c) => c.price,
              },
              {
                label: "Capacity",
                render: (c) => c.capacity,
              },
              {
                label: "Courier Company",
                render: (c) => c.courierCompany,
              },
              {
                label: "City",
                render: () => (
                  <button
                    onClick={openModal}
                    className="underline text-[#007AFF]"
                  >
                    View Cities
                  </button>
                ),
              },
              {
                label: "Payment Type",
                render: (c) => c.paymentType,
              },
              { label: "Date", render: (c) => c.date },
              {
                label: "Status",
                render: () => <ToggleButton />,
              },
              {
                label: "Actions",
                render: () => (
                  <button
                    onClick={openEditZoneToggleModal}
                    className="p-2 border rounded-full bg-[#F7F6F2]"
                  >
                    <IconEye />
                  </button>
                ),
              },
            ]}
          />
        </div>
      </div>

      <CommonModal
        title={"Add Zone"}
        open={openZone}
        closeButtonText={"Cancel"}
        onClose={openZoneToggleModal}
        actionButtonText="Add Zone"
        actionButtonOnClick={openZoneToggleModal}
      >
        <AddZoneModal />
      </CommonModal>
      <CommonModal
        title={"Zone Name"}
        open={openEditZone}
        closeButtonText={"Cancel"}
        onClose={openEditZoneToggleModal}
        actionButtonText="Edit"
        actionButtonOnClick={openEditZoneToggleModal}
      >
        <EditViewModal />
      </CommonModal>
      <ViewCitiesModal open={isOpen} onClose={closeModal} />
    </>
  );
}
